<!-- app/layouts/default.vue -->
<template>
  <div>
    <Header />
    <ClientOnly><Alert /></ClientOnly>
    <slot />
    <Footer />
  </div>
</template>
<script setup lang="ts">
</script>